// extracted by mini-css-extract-plugin
module.exports =  {"stopBodyYScroll":"HSpueU","quickAddMobileScrollContainer":"Zma_U8","root":"DCrJcf"};